import React, { useState } from 'react';
import { I } from '../../common/v5/config';
import { SelectInputRow } from '../../reactcomponents/Form';
import Button from '../../reactcomponents/Button';

const AgentSkillsManager = ({ 
  skills = [], 
  onSkillsChange, 
  availableSkills = [],
  proficiencyList = [],
  onSaveAgentSkill,
  onRemoveAgentSkill,
  onUpdateAgentSkill,
  agentId
}) => {
  const [showAddSkill, setShowAddSkill] = useState(false);
  const [selectedSkill, setSelectedSkill] = useState('');
  const [selectedProficiency, setSelectedProficiency] = useState(0); 

  // Use proficiencyList from props if available, otherwise use default options
  const proficiencyOptions = proficiencyList.length > 0 ? proficiencyList : [
    { id: 0, name: I('Optional') },
    { id: 1, name: I('Beginner') },
    { id: 2, name: I('Intermediate') },
    { id: 3, name: I('Expert') }
  ];

  const handleAddSkill = () => {
    if (selectedSkill && selectedProficiency) {
      const skillData = availableSkills.find(s => s.id === parseInt(selectedSkill));
      const newSkill = {
        id: Date.now(), 
        skillId: parseInt(selectedSkill),
        name: skillData?.name || '',
        proficiency: selectedProficiency
      };
      
      // If we have Redux actions, use them to save the skill
      if (onSaveAgentSkill && agentId) {
        const params = {
          agentId: agentId,
          skillId: parseInt(selectedSkill),
          proficiencyId: selectedProficiency
        };
        onSaveAgentSkill(params);
      } else {
        // Fallback to local state update
        onSkillsChange([...skills, newSkill]);
      }
      
      setSelectedSkill('');
      setSelectedProficiency(0); 
      setShowAddSkill(false);
    }
  };

  const handleRemoveSkill = (skillId) => {
    if (onRemoveAgentSkill && agentId) {
      const params = {
        id: skillId,
        agentId: agentId
      };
      onRemoveAgentSkill(params);
    } else {
      // Fallback to local state update
      onSkillsChange(skills.filter(skill => skill.id !== skillId));
    }
  };

  const availableSkillOptions = availableSkills
    .filter(skill => !skills.some(s => s.skillId === skill.id))
    .map(skill => ({ id: skill.id, name: skill.name }));



  const handleAddSkillClick = () => {
    setShowAddSkill(true);
  };

  const handleCancelClick = () => {
    setShowAddSkill(false);
    setSelectedSkill('');
    setSelectedProficiency(0); 
  };

  return (
    <div className="agent-skills-manager">
      <div className="skills-list">
        {skills.length === 0 ? (
          <p className="no-skills">{I('No skills assigned')}</p>
        ) : (
          skills.map(skill => (
            <div key={skill.id} className="skill-item">
              <span className="skill-name">{skill.name}</span>
              <span className="skill-proficiency">
                {proficiencyOptions.find(p => p.id === skill.proficiency)?.name || I('Unknown')}
              </span>
              <button 
                className="remove-skill-btn"
                onClick={() => handleRemoveSkill(skill.id)}
                title={I('Remove skill')}
                type="button"
              >
                <i className="icon-remove"></i>
              </button>
            </div>
          ))
        )}
      </div>

      {!showAddSkill ? (
        <Button
          className="add-skill-btn"
          onClick={handleAddSkillClick}
          disabled={availableSkillOptions.length === 0}
          type="button"
          text={I('Add Skill')}
        >
          <i className="icon-add"></i>
        </Button>
      ) : (
        <div className="add-skill-form">
          <SelectInputRow
            label={I('Skill')}
            name="selectedSkill"
            id="selectedSkill"
            value={selectedSkill}
            onSelect={(value) => setSelectedSkill(value)}
            option={availableSkillOptions}
            textNoItemSelected={I('Select skill')}
          />
          
          <SelectInputRow
            label={I('Proficiency')}
            name="selectedProficiency"
            id="selectedProficiency"
            value={selectedProficiency}
            onSelect={(value) => setSelectedProficiency(value)}
            option={proficiencyOptions}
          />
          
          <div className="add-skill-actions">
            <Button 
              onClick={handleAddSkill} 
              className="btn-primary"
              disabled={!selectedSkill}
              type="button"
              text={I('Add')}
            />
            <Button 
              onClick={handleCancelClick} 
              className="btn-secondary"
              type="button"
              text={I('Cancel')}
            />
          </div>
        </div>
      )}
      
      {availableSkillOptions.length === 0 && !showAddSkill && (
        <p className="no-more-skills">{I('All available skills have been assigned')}</p>
      )}
    </div>
  );
};

export default AgentSkillsManager; 